import React, {useEffect, useState, useMemo, useContext} from 'react';
import {getChantier} from '../../services/MadricService';
import './Chantier.css';
import {useNavigate} from 'react-router-dom';
import ChantierView from './ChantierView';
import {deleteChantier} from '../../services/MadricService';
import swal from 'sweetalert';
import Spinner from '../Spinner/Spinner';
import {MadricContext} from '../../Context/MadricContext';

/**
 * La logique des chantiers
 * @return {JSX}
 */
function Chantier() {
  const [places, setPlaces] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const {setIdProjectInfo, projectInfoObtained, setProjectInfo} = useContext(MadricContext);

  useEffect(() => {
    setResponsivePageSize();
    fetchPlaces();
    window.addEventListener('resize', setResponsivePageSize);
    return () => window.removeEventListener('resize', setResponsivePageSize);
  }, []);

  /**
   * Permet de naviguer vers un chantier
   * @param {*} id id du chantier
   */
  function navigateId(id) {
    navigate(`/chantier/${id}`);
    setProjectInfo([]);
    projectInfoObtained.current = [];
    setIdProjectInfo(null);
  }

  /**
   * Change le nombre d'éléments à afficher par pages
   */
  function setResponsivePageSize() {
    setPageSize(window.innerWidth <= 600 ? 9 : 18);
  }

  /**
   * Permet d'allez chercher la liste des chantiers
   */
  async function fetchPlaces() {
    const chantier = await getChantier();
    setPlaces(chantier);
  }

  const filteredPlaces = useMemo(() => {
    return places
        .filter((place) =>
          searchInput
              .toLowerCase()
              .split(' ')
              .every(
                  (term) =>
                    place.name?.toLowerCase().includes(term) ||
              place.client_name?.toLowerCase().includes(term) ||
              place.phone?.includes(term) ||
              place.contrat?.includes(term),
              ),
        );
  }, [searchInput, places]);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, filteredPlaces.length);

  const displayedPlaces = filteredPlaces.slice(startIndex, endIndex);

  /**
   * PErmet de gérer la searchBar
   * @param {*} e event
   */
  function handleSearchInput(e) {
    setSearchInput(e.target.value);
    setCurrentPage(1);
  }

  /**
   * Permet de changer de page
   * @param {*} newPage la page à afficher
   */
  function handlePageChange(newPage) {
    setCurrentPage(newPage);
  }

  const isButtonDisabled = (symbol) => {
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === Math.ceil(filteredPlaces.length / pageSize) || filteredPlaces.length === 0;
    return symbol.props.icon.iconName === 'angles-left' || symbol.props.icon.iconName === 'angle-left' ? isFirstPage : isLastPage;
  };

  /**
   * Permet de supprimer un chantier
   * @param {*} id id du chantier a supprimer
   */
  async function supprimer(id) {
    swal({
      title: '!! Êtes-vous sûre de vouloir supprimer ce projet !!',
      text: 'Une fois supprimé vous perderez toutes les informations relié à ce projet (photos comprises)',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    })
        .then(async (willDelete) => {
          if (willDelete) {
            swal('Supprimé!', {
              icon: 'success',
            });

            setPlaces((prevItems) => prevItems.filter((item) => item.id !== id));
            setIsLoading(true);
            await deleteChantier(id);
            setIsLoading(false);
          } else {
            swal('Annulé!');
          }
        });
  }

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <ChantierView
        searchInput={searchInput}
        handleSearchInput={handleSearchInput}
        currentPage={currentPage}
        places={places}
        setPlaces={setPlaces}
        pageSize={pageSize}
        handlePageChange={handlePageChange}
        isButtonDisabled={isButtonDisabled}
        displayedPlaces={displayedPlaces}
        navigateId={navigateId}
        supprimer={supprimer} />
    </React.Fragment>
  );
}

export default Chantier;
